var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataProviderFactory } from "app/provider/data2.provider";
import { BaseService } from "../views/base.service";
import { HttpClient } from "@angular/common/http";
var DomainsService = /** @class */ (function (_super) {
    __extends(DomainsService, _super);
    function DomainsService(dpf, http) {
        var _this = _super.call(this, http) || this;
        _this.dpf = dpf;
        _this.http = http;
        _this.actions = _this.dpf.getNew('domain_actions');
        _this.zones = _this.dpf.getNew('domain_zones');
        _this.expired = _this.dpf.getNew('expired_domains');
        return _this;
    }
    return DomainsService;
}(BaseService));
export { DomainsService };
